export const fileUploaderTypes = {
  clients: {
    title: "Upload Clients",
    infoTitle: "Upload Your Clients Dataset",
    sampleFileLink: "https://s3.ap-south-1.amazonaws.com/app.downloadables.bkp/Client+Data+Upload+Sample.xlsx",
    sampleFileName: "Client Data Upload Sample.xlsx",
  },
  services: {
    title: "Upload Services",
    infoTitle: "Upload Your Services Dataset",
    sampleFileLink: "https://s3.ap-south-1.amazonaws.com/app.downloadables.bkp/Service+Data+Upload+Sample.xlsx",
    sampleFileName: "Service Data Upload Sample.xlsx",
  },
  sellers: {
    title: "Upload Sellers",
    infoTitle: "Upload Your Sellers Dataset",
    sampleFileLink: "https://s3.ap-south-1.amazonaws.com/app.downloadables.bkp/Seller_sheet.xlsx",
  },
  inventoryDetails: {
    title: "Upload Inventory Details",
    infoTitle: "Upload Your Inventory Details Dataset",
    sampleFileLink: "https://s3.ap-south-1.amazonaws.com/app.downloadables.bkp/inventory_detail_sheet.xlsx",
  },
};
